<template>
    <div class="flag-for-timeline">
        <div class="flag-for-timeline__month">
            <slot />
        </div>
        <IconFlag class="flag-for-timeline__icon" />
    </div>
</template>

<script>
import IconFlag from '@/views/track/icons/IconFlag.vue';

export default {
    name: 'FlagForTimeline',
    components: {
        IconFlag,
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables';

.flag-for-timeline {
    position: absolute;
    bottom: 0;
    left: 0;
    width: urem(2);
    height: calc(100% + #{urem(90)});
    background-color: #69609f;
    z-index: 10;

    &__icon {
        position: absolute;
        top: urem(-10);
        right: 0;
        width: urem(84);
        height: urem(31);

        svg {
            width: urem(84);
            height: urem(31);
        }
    }

    &__month {
        position: absolute;
        top: urem(-25);
        right: urem(6);
        color: #69609f;
        font-size: urem(12);
        font-weight: 600;
        white-space: nowrap;
    }
}
</style>
